//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defer } from "lodash";
import RichTextEditor from "../../utils/rich-text-editor";
import DOMPurify from "dompurify";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailEditor",
  props: {
    emailSignature: {
      type: String,
      default: ""
    },
    emailBody: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: "6vw"
    },
    substitutionHints: {
      type: Boolean,
      default: false
    },
    showMergeTags: {
      type: Boolean,
      default: false
    },
    showApplicationMergeTags: {
      type: Boolean,
      default: false
    },
    attachments: {
      type: Boolean,
      default: false
    },
    airMode: {
      type: Boolean,
      default: false
    },
    signatureSeparator: {
      type: Boolean,
      default: true
    },
    mergeTags: {
      type: Array,
      default: () => []
    },
    hints: {
      type: Array,
      default: () => []
    },
    participants: {
      type: Array,
      default: () => []
    },
    generateEmail: {
      type: Boolean,
      default: false
    },
    generateEmailBody: {
      type: String,
      default: ""
    },
    dialogsInBody: {
      type: Boolean,
      default: false
    },
    loadedAttachments: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      editor: {}
    };
  },
  computed: {
    preLoadContent() {
      if (this.emailBody && this.emailBody !== this.emailSignature) return this.emailBody;
      return this.emailSignature.replace("<br>", "") ? `${this.signatureSeparator ? "<br> -- <br> " : ""}${this.emailSignature}` : "";
    }
  },
  watch: {
    hints: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    mergeTags: {
      deep: true,
      handler(value) {
        this.editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    participants: {
      deep: true,
      handler(value) {
        if (this.editor && this.editor.updateOptions) {
          this.editor.updateOptions({
            participants: value
          });
        }
      }
    },
    generateEmailBody: {
      handler(value) {
        const email = `${value} <br/> ${this.emailSignature.replace("<br>", "") ? `${this.signatureSeparator ? "<br> -- <br> " : ""}${this.emailSignature}` : ""}`;
        const raw = value ? value : email;
        const clean = DOMPurify.sanitize(raw);
        this.editor.setHTML(clean);
      }
    },
    initialAttachments: {
      deep: true,
      handler(value) {
        var _this$editor;
        if (!((_this$editor = this.editor) != null && _this$editor.setAttachedFiles)) return;
        this.editor.setAttachedFiles(value || []);
      }
    }
  },
  mounted() {
    this.loading = true;
    this.$nextTick(() => {
      defer(() => {
        this.init();
        this.loading = false;
      });
    });
  },
  updated() {
    if ($("#email-editor").exists() && !$("#email-editor-wrapper .note-editor").exists()) {
      this.init();
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const {
          height,
          substitutionHints,
          showMergeTags,
          showApplicationMergeTags,
          attachments,
          generateEmail,
          airMode,
          mergeTags,
          hints,
          participants,
          dialogsInBody
        } = this;
        this.editor = new RichTextEditor(this.$refs.emailEditor, {
          height,
          substitutionHints,
          showMergeTags,
          showApplicationMergeTags,
          attachments,
          generateEmail,
          airMode,
          mergeTags: defaults => {
            return [...defaults, ...mergeTags];
          },
          participants,
          hints: defaults => {
            return [...defaults, ...hints];
          },
          callbacks: {
            onChange: this.handleEditorChange,
            onAttachmentChange: this.handleAttachmentChange,
            onOpenGenerateEmailModal: this.handleGenerateEmail
          },
          dialogsInBody
        });
        this.editor.setAttachedFiles(this.initialAttachments || []);
        const clean = DOMPurify.sanitize(this.preLoadContent || "");
        this.editor.setHTML(clean);
      });
    },
    handleEditorChange(target, content) {
      this.$emit("change", {
        target,
        content
      });
    },
    handleGenerateEmail() {
      this.$emit("open-modal");
    },
    clearTemplate() {
      $(this.$refs.emailEditor).summernote("reset");
      this.editor.setHTML(this.preLoadContent || "");
      this.editor._loadStorage();
      this.editor.clearAttachedfiles();
    },
    focusIn() {
      $(this.$refs.emailEditor).summernote("focus");
    },
    codeText(text) {
      this.$nextTick(() => {
        $(this.$refs.emailEditor).summernote("code", text);
      });
    },
    insertText(text) {
      $(this.$refs.emailEditor).summernote("insertText", text);
    },
    getBody() {
      return $(this.$refs.emailEditor).summernote("code");
    },
    getHTML() {
      return this.editor.getHTML();
    },
    setHtml(html) {
      this.editor.setHTML(html);
    },
    setAttachments(attachments) {
      this.editor.setAttachedFiles(attachments);
    },
    handleAttachmentChange(attachments) {
      this.$emit("attachment-change", attachments);
    }
  }
});